/* eslint-disable jsx-a11y/anchor-is-valid */
import {KTableProvider} from '../../../../../../contexts/KTableProvider'
import {TableLaundryBatch} from './laundry'

const TableLaundryBatchWrapper = () => {
  return (
    <KTableProvider>
      <TableLaundryBatch />
    </KTableProvider>
  )
}

export {TableLaundryBatchWrapper}
